module.exports = __webpack_public_path__ + "img/edit-icon.f7a0d198.svg";